module.exports = __webpack_public_path__ + "static/3-f8083aa973a76763e7709e80b19d3d11.jpg";